module.exports = __webpack_public_path__ + "img/signin.f0130260.jpg";